import AdminDashboard from '../admin/AdminDashboard';

export default AdminDashboard;
